import { InputFieldSet, InputFieldSetProps } from "PFComponents/text/input_field_set";
import { UseNumberInput, useNumberInput } from "PFCore/hooks/use_number_input";
import { ForwardedRef, forwardRef } from "react";

export type DecimalNumberInputProps = Omit<InputFieldSetProps, "value" | "onChange" | "inputType" | "type"> &
  Omit<UseNumberInput, "onChange"> & {
    onChange: (value: number | undefined) => void;
  };

export const DecimalNumberInput = forwardRef(
  (props: DecimalNumberInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    const { min, max, onChange, disabled, controlledValue, defaultValue, ...rest } = props;

    const { value, handleChange } = useNumberInput(props as UseNumberInput);

    const inputMode = rest.inputMode ?? "decimal";

    return (
      // @ts-ignore ts cannot narrow the InputFieldSet input/textarea union through the omitted props here
      <InputFieldSet
        {...rest}
        ref={ref}
        disabled={disabled}
        value={value}
        onChange={handleChange}
        inputMode={inputMode}
      />
    );
  }
);

DecimalNumberInput.displayName = "DecimalNumberInput";
